// export type FindOperationChainItemsDto = {
//   activityId: string
//   activityName: string
//   position: number
// }

import {
  FindOperationChainItemsPathParams,
  useFindOperationChainItems,
} from "~/gen/api"

// export const useFindOperationChainItemsQuery = (
//   operationChainId: string | null
// ) =>
//   useQuery({
//     queryKey: ["findOperationChainItems", operationChainId],
//     enabled: !!operationChainId,
//     queryFn: async () => {
//       const res = await httpClient.get<FindOperationChainItemsDto[]>(
//         `/admin/product-management/find-operation-chain-items/${operationChainId}`
//       )
//       return res.data
//     },
//   })

export const useFindOperationChainItemsQuery = (
  params: FindOperationChainItemsPathParams
) =>
  useFindOperationChainItems(params.operationChainId, {
    query: {
      enabled: !!params.operationChainId,
    },
  })
